import React from 'react';
import PropTypes from "prop-types";

const PortfolioDetailsThumb = ({images, slug}) => {
    const renderVideo = (path, i) => (
        <video key={i} width="430" height="auto" controls autoplay>
            <source src={require(`../../../../assets/images/portfolio/${slug}/${path}`)} type="video/mp4"/>
        </video>)

    const renderYoutube = (path, i) => (
        <div key={i} class="ratio ratio-9x16">
            <iframe src={path}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen></iframe>
        </div>)
    const renderImg = (path, i) => (<img key={i} src={require(`../../../../assets/images/portfolio/${slug}/${path}`)} alt="portfolio"/>)

    return (
        <div className="portfolio-details-image mb-sm-30 mb-xs-30">
            {images.map((image, index) => (
                (image.indexOf('youtube') > -1) ? renderYoutube(image, index) : image.indexOf('mp4') > -1 ? renderVideo(image, index) : renderImg(image, index)
            ))}
        </div>
    );
};

PortfolioDetailsThumb.prototype = {
    images: PropTypes.array
};

PortfolioDetailsThumb.defaultProps = {
    images: [
        "https://via.placeholder.com/670x430",
        "https://via.placeholder.com/670x430"
    ]
};

export default PortfolioDetailsThumb;